import React from 'react';
import { Box, Container, Heading, Text, VStack, Grid, GridItem, Image } from '@chakra-ui/react';
import AproposBg from '../utils/images/image_apropos.png';
import Header from '../components/Header.jsx';
import Footer from '../components/Footer.jsx';

const APropos = () => {
  return (
    <Box minH="100vh" display="flex" flexDirection="column" bg="white">
      <Header />
      <Box as="main" flex="1" pt={["100px", "100px", "90px", "90px"]}>
        {/* Section 1 – iOS light background */}
        <Box
          left="50%"
          ml="-50vw"
          w="100vw"
          position="relative"
          bg="transparent"
          py={{ base: 12, lg: 16 }}
        >
          <Container maxW="1200px" px={5}>
            <Grid templateColumns={{ base: '1fr', lg: '1fr 1fr' }} gap={{ base: 10, lg: 16 }} alignItems="center">
              <GridItem>
                <VStack align="start" spacing={5} textAlign="left">
                  <Heading as="h2" size="xl" fontWeight={800} color="gray.900">
                    🌱 Notre mission : vous accompagner vers un avenir plus vert
                  </Heading>
                  <VStack spacing={4} maxW="700px">
                    <Text color="gray.700">
                      Réduire vos factures d'énergie tout en préservant l'environnement est devenu un enjeu majeur pour tous les propriétaires. Entre les aides de l'État, les démarches administratives et le choix des équipements, la rénovation énergétique peut sembler complexe.
                    </Text>
                    <Text color="gray.700">
                      Groupe Solarenov est une entreprise française intervenant sur l'ensemble du territoire, spécialisée dans les solutions énergétiques durables. Nous nous distinguons par notre engagement à utiliser exclusivement du matériel haut de gamme.
                    </Text>
                    <Text color="gray.700">
                      Nous vous proposons une solution complète pour tous vos projets de rénovation énergétique :
                    </Text>
                    <VStack align="start" spacing={2} color="gray.700">
                      <Text>• Installation de panneaux photovoltaïques haut de gamme,</Text>
                      <Text>• Maintenance préventive et interventions rapides,</Text>
                      <Text>• Études personnalisées et conseil énergétique,</Text>
                      <Text>• Montage des dossiers administratifs et financiers.</Text>
                    </VStack>
                  </VStack>
                </VStack>
              </GridItem>
              <GridItem>
                <Image
                  src={AproposBg}
                  alt="Groupe Solarenov - Installation pompe à chaleur"
                  borderRadius="3xl"
                  boxShadow="0 25px 80px rgba(0,0,0,0.15)"
                  w="100%"
                  h={{ base: '260px', md: '360px', lg: '480px' }}
                  objectFit="cover"
                />
              </GridItem>
            </Grid>
          </Container>
        </Box>

        {/* Section 2 – iOS vibrant gradient */}
        <Box
          left="50%"
          ml="-50vw"
          w="100vw"
          position="relative"
          bg="transparent"
          py={{ base: 12, lg: 16 }}
        >
          <Container maxW="1200px" px={5}>
            <Box
              borderRadius="3xl"
              overflow="hidden"
              bg="white"
              border="1px solid"
              borderColor="gray.100"
              boxShadow="0 12px 40px rgba(0,0,0,0.08)"
              p={{ base: 6, lg: 8 }}
            >
              <VStack spacing={6} align="start" textAlign="left" color="gray.800" w="full">
                <Box w="64px" h="6px" bg="linear-gradient(90deg, #ffffff 0%, rgba(255,255,255,0.6) 50%, #ffffff 100%)" borderRadius="full" />
                <Heading as="h2" size="md" fontWeight={800} color="gray.900" textAlign="center" alignSelf="center">⭐ Pourquoi choisir Groupe Solarenov ?</Heading>
                <VStack spacing={4} maxW="900px" color="gray.700" align="start" w="full">
                  <Text textAlign="left">1. <b>Qualification RGE QUALI PV</b> – Nos artisans sont certifiés Reconnus Garants de l'Environnement.</Text>
                  <Text textAlign="left">2. <b>Rapidité</b> – Devis personnalisé sous 24h et installation dans les meilleurs délais.</Text>
                  <Text textAlign="left">3. <b>Réduction de facture</b> – Réduisez votre facture d'électricité de moitié.</Text>
                  <Text textAlign="left">4. <b>Aides maximisées</b> – Nous optimisons vos subventions (MaPrimeRénov', CEE, éco-PTZ).</Text>
                  <Text textAlign="left">5. <b>Matériel haut de gamme</b> – Nous utilisons exclusivement du matériel premium pour garantir fiabilité et performance.</Text>
                </VStack>
                <Text fontWeight={700} color="gray.800" textAlign="left">
                  Faites confiance à Groupe Solarenov pour vous accompagner vers un avenir plus vert, durable et moins coûteux.
                </Text>
              </VStack>
            </Box>
          </Container>
        </Box>

        {/* Section Tarifs */}
        <Container maxW="1200px" px={5} py={{ base: 10, lg: 14 }}>
          <Box
            borderRadius="3xl"
            overflow="hidden"
            boxShadow="0 12px 40px rgba(0,0,0,0.08)"
            bg="white"
            border="1px solid"
            borderColor="gray.100"
            p={{ base: 6, lg: 8 }}
          >
            <VStack align="start" spacing={4}>
              <Heading as="h2" size="md" fontWeight={800} color="gray.900" textAlign="center" alignSelf="center">💰 Nos solutions tarifaires</Heading>
              <VStack align="start" spacing={2} color="gray.700">
                <Text>• Pompe à chaleur : Aides jusqu'à 70% du coût</Text>
                <Text>• Isolation des combles : À partir de 0€ après aides</Text>
                <Text>• Panneaux solaires : Aides jusqu'à 40% du coût</Text>
                <Text>• Audit énergétique complet : Gratuit pour éligibles</Text>
                <Text>• Rénovation globale : Devis personnalisé selon votre projet</Text>
              </VStack>
            </VStack>
          </Box>
        </Container>

        {/* Section Process */}
        <Container maxW="1200px" px={5} py={{ base: 2, lg: 2 }}>
          <Box
            borderRadius="3xl"
            overflow="hidden"
            boxShadow="0 12px 40px rgba(0,0,0,0.08)"
            bg="white"
            border="1px solid"
            borderColor="gray.100"
            p={{ base: 6, lg: 8 }}
          >
            <VStack align="start" spacing={4}>
              <Heading as="h2" size="md" fontWeight={800} color="gray.900" textAlign="center" alignSelf="center">⚙️ Notre processus en 4 étapes</Heading>
              <VStack align="start" spacing={2} color="gray.700">
                <Text>1. <b>Diagnostic gratuit</b> – Audit énergétique complet de votre logement (isolation, chauffage, ventilation).</Text>
                <Text>2. <b>Devis personnalisé</b> – Proposition sur mesure avec optimisation des aides financières disponibles.</Text>
                <Text>3. <b>Accompagnement administratif</b> – Nous gérons toutes vos démarches d'aides (MaPrimeRénov', CEE, éco-PTZ).</Text>
                <Text>4. <b>Installation et suivi</b> – Réalisation par nos artisans RGE certifiés, avec garantie décennale et maintenance.</Text>
              </VStack>
              <Text fontWeight={600} color="gray.800" textAlign="left">
                💡 <b>Bonus :</b> Vous bénéficiez d'un accompagnement personnalisé tout au long de votre projet, de l'étude initiale à la maintenance de vos équipements.
              </Text>
            </VStack>
          </Box>
        </Container>

        {/* Section Publics */}
        <Container maxW="1200px" px={5} py={{ base: 2, lg: 2 }}>
          <Box
            borderRadius="3xl"
            overflow="hidden"
            boxShadow="0 12px 40px rgba(0,0,0,0.08)"
            bg="white"
            border="1px solid"
            borderColor="gray.100"
            p={{ base: 6, lg: 8 }}
          >
            <VStack align="start" spacing={4}>
              <Heading as="h2" size="md" fontWeight={800} color="gray.900" textAlign="center" alignSelf="center">🏠 Des solutions adaptées à tous les logements</Heading>
              <VStack align="start" spacing={2} color="gray.700">
                <Text>• <b>Maisons individuelles</b> – Optimisation complète de l'isolation et du chauffage</Text>
                <Text>• <b>Appartements</b> – Solutions adaptées aux contraintes de copropriété</Text>
                <Text>• <b>Logements anciens</b> – Rénovation énergétique complète avec aides maximales</Text>
                <Text>• <b>Constructions récentes</b> – Amélioration des performances énergétiques</Text>
              </VStack>
              <Text color="gray.700">Que vous soyez propriétaire ou locataire, nous adaptons nos solutions à votre situation pour maximiser vos économies d'énergie et votre confort.</Text>
            </VStack>
          </Box>
        </Container>

        {/* Section Engagement */}
        <Container maxW="1200px" px={5} py={{ base: 2, lg: 2 }}>
          <Box
            borderRadius="3xl"
            overflow="hidden"
            boxShadow="0 12px 40px rgba(0,0,0,0.08)"
            bg="white"
            border="1px solid"
            borderColor="gray.100"
            p={{ base: 6, lg: 8 }}
          >
            <VStack align="start" spacing={4}>
              <Heading as="h2" size="md" fontWeight={800} color="gray.900" textAlign="center" alignSelf="center">🤝 Notre engagement qualité</Heading>
              <VStack align="start" spacing={2} color="gray.700">
                <Text>• <b>Expertise certifiée</b> – Artisans RGE avec plus de 10 ans d'expérience</Text>
                <Text>• <b>Garanties complètes</b> – Garantie décennale et maintenance incluse</Text>
                <Text>• <b>Transparence totale</b> – Devis détaillé sans frais cachés</Text>
                <Text>• <b>Économies garanties</b> – Réduction minimale de 30% sur vos factures</Text>
                <Text>• <b>Impact environnemental</b> – Réduction de votre empreinte carbone</Text>
              </VStack>
            </VStack>
          </Box>
        </Container>

        {/* Section Contact CTA */}
        <Container maxW="1200px" px={5} py={{ base: 6, lg: 10 }}>
          <Box
            bg="linear-gradient(135deg, #094c26, #0d6b35, #063a1d)"
            borderRadius="2xl"
            p={{ base: 8, lg: 12 }}
            color="white"
            textAlign="center"
          >
            <VStack spacing={4}>
              <Heading size="md" fontWeight={800} textAlign="center">🌱 Prêt pour votre transition énergétique ?</Heading>
              <Text fontSize="lg">Réduisez vos factures jusqu'à 70% et participez à la protection de l'environnement !</Text>
              <Text>➡️ <b>Demandez votre devis gratuit</b> en 2 minutes et recevez un rappel sous 24h de nos experts.</Text>
              <Text>💰 <b>Aides jusqu'à 90%</b> – Nos conseillers optimisent automatiquement vos subventions disponibles.</Text>
            </VStack>
          </Box>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
};

export default APropos;


